export const QUOTA_LEVEL_TRACKING = {
  MODAL_TITLE: 'Quota Level Tracking',
  CHAR_COUNT_VALIDATION_FAIL: 'charcountvalidationfail',
  CHAR_COUNT_VALIDATION_MESSAGE: `We are sorry, the following quota codes should have maximum 15 characters per code :-`,
  UNIQUE_FAIL: 'uniquefail',
  UNIQUE_FAIL_MESSAGE: `We are sorry, the following quota codes have already been used :-`,
  INPUT_VALIDATION_FAIL: 'inputvalidationfail',
  INPUT_VALIDATION_FAIL_MESSAGE: `You have selected to enable Quota Level Tracking on this survey. Before we can launch your project,
    we need you to input a unique Quota Code into all of the fields.`,
  LAUNCH: 'launch',
};
